import { render, staticRenderFns } from "./PlayerInfo.vue?vue&type=template&id=7880181a&scoped=true&"
import script from "./PlayerInfo.vue?vue&type=script&lang=js&"
export * from "./PlayerInfo.vue?vue&type=script&lang=js&"
import style0 from "./PlayerInfo.vue?vue&type=style&index=0&id=7880181a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7880181a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VIcon,VSimpleTable})
